"use client";

import { FC, useCallback } from "react";
import { usePostHog } from "posthog-js/react";
import { AuthProvider, useDatadog } from "@auth/client-sdk-react";

import { PublicConfig } from "../config/public";
import { WithChildren } from "../types";

export const WebsiteAuthProvider: FC<WithChildren>
  = ({ children }) => {

    const posthog = usePostHog();
    const datadog = useDatadog();

    const onLogout = useCallback(() => {
      posthog.reset();
      datadog.clearGlobalContext();
    }, [ posthog, datadog ]);

    return (
      <AuthProvider
        onLogout={ onLogout }
        authConfig={ {
          AUTH_API_BASE_URL: PublicConfig.AUTH_API_BASE_URL,
          NEXT_PUBLIC_COOKIE_DOMAIN: PublicConfig.NEXT_PUBLIC_COOKIE_DOMAIN,
          NEXT_PUBLIC_WEBSITE_URL: PublicConfig.NEXT_PUBLIC_WEBSITE_URL,
        } }
      >
        { children }
      </AuthProvider>
    );
  };
